module.exports = __webpack_public_path__ + "plus-2021jump/images/new_item_list_ttl.e7effc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_item_list_ttl.png
// module id = mbbz
// module chunks = 0